'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".skeleton-box {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  overflow: hidden;\n  background-color: #DDDBDD;\n}\n.skeleton-box__square {\n  width: 100%;\n}\n.skeleton-box__circle {\n  border-radius: 100%;\n}\n.skeleton-box__sm.skeleton-box__circle {\n  width: 5em;\n  height: 5em;\n}\n.skeleton-box__md {\n  height: 5em;\n}\n.skeleton-box__md.skeleton-box__circle {\n  width: 10em;\n  height: 10em;\n}\n.skeleton-box__lg {\n  height: 10em;\n}\n.skeleton-box__lg.skeleton-box__circle {\n  width: 15em;\n  height: 15em;\n}\n.skeleton-box::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transform: translateX(-100%);\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));\n  animation: shimmer 2s infinite;\n  content: \"\";\n}\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}");
//# sourceMappingURL=Skeleton.scss.js.map
